import React from 'react'
import { Draggable } from 'react-smooth-dnd'

const Cards = (props) => {
  return <Draggable key={props.id}>{props.children}</Draggable>
}

export default Cards
